<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
      </div>
      <div style="width: 600px">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="活动名称" prop="activityName">
            <el-input
              v-model="ruleForm.activityName"
              placeholder="请输入活动名称"
            />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker
              v-model="ruleForm.activityTime"
              type="daterange"
              range-separator="至"
              start-placeholder="请选择开始日期"
              end-placeholder="请选择结束日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="活动说明" prop="activityExplain">
            <el-input
              v-model="ruleForm.activityExplain"
              type="textarea"
              :rows="4"
              placeholder="请输入活动说明"
            />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px">
        <el-form
          ref="configForm"
          :model="configForm"
          :rules="configRules"
          label-width="100px"
        >
          <el-form-item label="组团规则" prop="activityReason">
            <el-input
              v-model="configForm.activityReason"
              type="textarea"
              :rows="4"
              placeholder="请输入活动规则"
            />
          </el-form-item>
          <el-form-item label="活动文案" prop="activityCopywriting">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              accept=".jpg, .jpeg, .png, .gif"
            >
              <img
                v-if="configForm.activityCopywriting"
                :src="
                  this.action + '?objectName=' + configForm.activityCopywriting
                "
                class="avatar"
              >
              <span v-else class="imgborder">
                <i class="el-icon-plus avatar-uploader-icon" />
              </span>
            </el-upload>
            <span>只能上传.jpg, .jpeg, .png,
              .gif文件，且不超过1MB(建议尺寸：410*171)</span>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">成团条件</span>
      </div>
      <div style="width: 600px">
        <el-form
          ref="configForm2"
          :model="configForm2"
          :rules="groupRules"
          label-width="100px"
        >
          <el-form-item label="成团人数" prop="activityGroup">
            <el-input
              v-model="configForm2.activityGroup"
              placeholder="请输入参团成功的人数"
            />
          </el-form-item>
          <el-form-item label="消费维度" prop="consumptionDimension">
            <el-radio-group v-model="configForm2.consumptionDimension">
              <el-radio label="2">金额</el-radio>
              <el-radio label="1">电量</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖励标准" prop="amount">
            <div
              v-if="configForm2.consumptionDimension === '1'"
              class="d-flex amount"
            >
              <div class="mr-10">满</div>
              <el-input
                v-model="configForm2.amount" type="number"
                placeholder="请输入电度数"
              />
              <div class="ml-10">度</div>
            </div>
            <div
              v-if="configForm2.consumptionDimension === '2'"
              class="d-flex amount"
            >
              <div class="mr-10">满</div>
              <el-input
                v-model="configForm2.amount" type="number"
                placeholder="请输入金额"
              />
              <div class="ml-10">元</div>
            </div>
          </el-form-item>
          <el-form-item label="活动电站" prop="stationType">
            <el-radio-group v-model="configForm2.stationType" @change="configCancelTree()">
              <el-radio
                v-for="(item, index) in activitystationType"
                :key="index"
                :label="item.id"
              >{{ item.label }}
              </el-radio>
            </el-radio-group>
            <!-- 选择运营商 -->
            <div v-show="configForm2.stationType === '2'" class="border">
              <el-input
                v-model="filterOperatorText"
                placeholder="输入关键字进行过滤"
              />
              <el-tree
                ref="treeOperator"
                :data="operatorTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                :default-checked-keys="configForm2.operator"
                @check-change="handleOperatorChange"
              />
            </div>
            <!-- 选择电站 -->
            <div v-show="configForm2.stationType === '3'" class="border">
              <el-input
                v-model="filterStationText"
                placeholder="输入关键字进行过滤"
              />
              <el-tree
                ref="treeStation"
                :data="stationTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                :default-checked-keys="configForm2.station"
                @check-change="handleStationChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动奖励</span>
      </div>
      <div style="width: 550px">
        <div>团长奖励</div>
        <el-form
          ref="rewardForm"
          :model="rewardForm"
          :rules="rewardRules"
          label-width="100px"
        >
          <template v-for="(row, index) in rewardForm.coupons">
            <el-form-item
              :key="index"
              :label="'优惠券' + numberfilter(index + 1)"
              prop="activityReward"
            >
              <div class="d-flex">
                <el-select
                  v-model="row.couponId"
                  filterable
                  style="width: 200px"
                  placeholder="请选择优惠券"
                >
                  <el-option
                    v-for="item in allCoupon"
                    :key="item.couponId"
                    :label="item.couponName"
                    :value="item.couponId"
                  />
                </el-select>
                <el-input
                  v-model="row.count"
                  type="number"
                  class="ml-20"
                  style="width: 100px"
                  placeholder="请输入数量"
                />
                <div class="ml-20">张</div>
                <i
                  class="icon-jia ml-20 el-icon-circle-plus-outline"
                  @click="addCoupon(index)"
                />
                <i
                  v-show="index !== 0"
                  class="icon-jia ml-20 el-icon-remove-outline"
                  @click="delCoupon(index)"
                />
              </div>
              <div class="d-flex currentStock">
                当前库存：{{ queryCouponStock(row.couponId) }}
              </div>
            </el-form-item>
          </template>
        </el-form>
        <div>团员奖励</div>
        <el-form
          ref="rewardForm2"
          :model="rewardForm2"
          :rules="rewardRules2"
          label-width="100px"
        >
          <template v-for="(row, index) in rewardForm2.coupons">
            <el-form-item
              :key="index"
              :label="'优惠券' + numberfilter(index + 1)"
              prop="activityReward"
            >
              <div class="d-flex">
                <el-select
                  v-model="row.couponId"
                  filterable
                  style="width: 200px"
                  placeholder="请选择优惠券"
                >
                  <el-option
                    v-for="item in allCoupon"
                    :key="item.couponId"
                    :label="item.couponName"
                    :value="item.couponId"
                  />
                </el-select>
                <el-input
                  v-model="row.count"
                  type="number"
                  class="ml-20"
                  style="width: 100px"
                  placeholder="请输入数量"
                />
                <div class="ml-20">张</div>
                <i
                  class="icon-jia ml-20 el-icon-circle-plus-outline"
                  @click="addCoupon2(index)"
                />
                <i
                  v-show="index !== 0"
                  class="icon-jia ml-20 el-icon-remove-outline"
                  @click="delCoupon2(index)"
                />
              </div>
              <div class="d-flex currentStock">
                当前库存：{{ queryCouponStock(row.couponId) }}
              </div>
            </el-form-item>
          </template>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px">
        <el-form
          ref="partakeForm"
          :model="partakeForm"
          :rules="partakeRules"
          label-width="100px"
        >
          <el-form-item label="可参与用户" prop="userType">
            <el-radio-group v-model="partakeForm.userType" @change="partakeCancelTree()">
              <el-radio
                v-for="(item, index) in userTypeItem"
                :key="index"
                :label="item.id"
              >{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择企业 -->
            <div v-show="partakeForm.userType === '2'" class="border">
              <el-input
                v-model="filterMechanismText"
                placeholder="输入关键字进行过滤"
              />
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                :default-checked-keys="partakeForm.mechanism"
                @check-change="handleMechanismChange"
				:check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.userType === '3'" class="border">
              <el-input
                v-model="filterTagText"
                placeholder="输入关键字进行过滤"
              />
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                :default-checked-keys="partakeForm.tag"
                @check-change="handleTagChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
import { numberfilter } from '@/utils/tool'
const token = window.localStorage.getItem('token')
export default {
  data() {
    return {
      dataId: '',
      rewardForm: {
        coupons: [
          {
            couponId: '', // 优惠券id
            count: '' // 优惠券数量
          }
        ]
      },
      rewardRules: {
        activityReward: {
          required: true,
          trigger: 'change',
          validator: (rewardRules, value, cb) => {
            if (this.rulesRewardRule) {
              return cb(new Error(this.rulesRewardRule))
            }
            return cb()
          }
        }
      },
      rewardForm2: {
        coupons: [
          {
            couponId: '', // 优惠券id
            count: '' // 优惠券数量
          }
        ]
      },
      rewardRules2: {
        activityReward: {
          required: true,
          trigger: 'change',
          validator: (rewardRules, value, cb) => {
            if (this.rulesRewardRule2) {
              return cb(new Error(this.rulesRewardRule2))
            }
            return cb()
          }
        }
      },
      // 活动奖励表单数据
      // 活动电站
      activitystationType: [
        {
          label: '全部电站',
          id: '1'
        },
        {
          label: '选择运营商',
          id: '2'
        },
        {
          label: '选择电站',
          id: '3'
        }
      ],
      configForm2: {
        stationType: '1', // 活动电站单选框
        operator: [], // 选择运行商时的树数据
        station: [],
        activityGroup: '',
        consumptionDimension: '2', // 消费维度
        amount: ''
      },
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      operatorTreeData: [],
      filterOperatorText: '', // 运营商过滤
      filterMechanismText: '', // 企业过滤
      filterTagText: '', // 标签过滤
      // 活动信息表单
      filterStationText: '',
      stationTreeData: [],
      ruleForm: {
        activityName: '', // 活动名称
        activityTime: [], // 活动时间
        activityExplain: '' // 活动说明
      },
      // 活动信息表单校验
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        activityExplain: [
          { required: true, message: '请输入活动说明', trigger: 'blur' }
        ]
      },
      groupRules: {
        activityGroup: [
          { required: true, message: '请输入成团人数', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '请输入正整数', trigger: 'blur'}
        ],
        consumptionDimension: [
          { required: true, message: '请选择消费维度', trigger: 'change' }
        ],
        amount: [
          { required: true, message: '请输入奖励标准', trigger: 'blur' }
        ],
        stationType: [
          {
            required: true,
            message: '请选择活动电站',
            trigger: 'change'
          }
        ]
      },
      // 所有的优惠券数据
      allCoupon: [],
      // 活动配置表单
      configForm: {
        activityCopywriting: '',
        activityReason: ''
      },
      // 活动配置表单校验
      configRules: {
        activityCopywriting: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        activityReason: [
          { required: true, message: '请输入组团规则', trigger: 'blur' }
        ]
      },
      // 可参与用户字段的单选数据
      userTypeItem: [
        {
          label: '全部用户',
          id: '1'
        },
        {
          label: '选择企业',
          id: '2'
        },
        {
          label: '选择标签',
          id: '3'
        }
      ],
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      // 可参与用户表单
      partakeForm: {
        userType: '1', // 可参与用户的单选字段
        mechanism: [], // 选择企业
        tag: [] // 选择标签
      },
      partakeRules: {
        userType: [
          { required: true, message: '请选择可参与用户', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    headers() {
      // console.log(token);
      return {
        token: token
      }
    },
    action() {
      return HOST + '/oss'
    },
    // 活动配置表单的动态校验
    rulesRewardRule() {
      const dataArray = this.rewardForm.coupons
      for (let i = 0; i < dataArray.length; i++) {
        const currentObj = dataArray[i]
        if (currentObj.couponId === '' && !currentObj.couponId.length) {
          return '请选择优惠券'
        }
        if (!currentObj.count && !currentObj.count.length) {
          return '请输入数量'
        }
        if (this.queryCouponStock(currentObj.couponId) && currentObj.count > this.queryCouponStock(currentObj.couponId)) {
          return '优惠券数量大于库存数量'
        }
      }
      return ''
    },
    rulesRewardRule2() {
      const dataArray = this.rewardForm2.coupons
      for (let i = 0; i < dataArray.length; i++) {
        const currentObj = dataArray[i]
        if (currentObj.couponId === '' && !currentObj.couponId.length) {
          return '请选择优惠券'
        }
        if (!currentObj.count && !currentObj.count.length) {
          return '请输入数量'
        }
        if (this.queryCouponStock(currentObj.couponId) && currentObj.count > this.queryCouponStock(currentObj.couponId)) {
          return '优惠券数量大于库存数量'
        }
      }
      return ''
    }
  },
  watch: {
    filterOperatorText(val) {
      this.$refs.treeOperator.filter(val)
    },
    filterStationText(val) {
      this.$refs.treeStation.filter(val)
    },
    filterMechanismText(val) {
      this.$refs.treeMechanism.filter(val)
    },
    filterTagText(val) {
      this.$refs.treeTag.filter(val)
    }
  },
  mounted() {
  // 获取全部优惠券数据
    this.loadCoupon()
    // 查询全部企业方法
    this.getMechanismTree()
    // 查询全部标签方法
    this.getTagTree()
    // 查询全部运营商方法
    this.getOperatorTree()
    // 查询全部电站方法
    this.getStationTree()
    this.dataId = this.$route.query.id
    this.$nextTick(() => {
      // 获取数据
      this.getData()
    })
  },
  methods: {
    // 切换活动电站时 取消活动电站的树的选择
    configCancelTree() {
      this.$refs.treeOperator.setCheckedKeys([])
      this.$refs.treeStation.setCheckedKeys([])
    },
    // 切换可参与用户时 取消可参与用户的树的选择
    partakeCancelTree() {
      this.$refs.treeMechanism.setCheckedKeys([])
      this.$refs.treeTag.setCheckedKeys([])
    },
    getOperatorTree() {
      const data = {
        treeDepth: 'ORG'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: (resp) => {
          this.operatorTreeData = resp
        }
      })
    },
    // 查询全部电站树的数据
    getStationTree() {
      const data = {
        treeDepth: 'STATION'
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/tree',
        data: data,
        callback: (resp) => {
          this.stationTreeData = resp
        }
      })
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: (resp) => {
          this.mechanismTreeData = resp
        }
      })
    },
    handleOperatorChange(data, checked, indeterminate) {
      this.configForm2.operator = this.$refs.treeOperator.getCheckedKeys()
    },
    // 选择电站 赋值
    handleStationChange(data, checked, indeterminate) {
      this.configForm2.station = this.$refs.treeStation.getCheckedKeys()
    },
    // 选择企业 赋值
    handleMechanismChange(data, checked, indeterminate) {
      this.partakeForm.mechanism = this.$refs.treeMechanism.getCheckedKeys()
    },
    // 选择标签 赋值
    handleTagChange(data, checked, indeterminate) {
      this.partakeForm.tag = this.$refs.treeTag.getCheckedKeys()
    },
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000,
        status: 0,
        hasStock: true
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: (resp) => {
          console.log(resp)
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.$forceUpdate()
          }
        }
      })
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType:'0' },
        callback: (resp) => {
          this.tagTreeData = resp
        }
      })
    },
    /**
     * 表单添加一行优惠券
     */
    addCoupon(index) {
      const data = {
        couponId: '',
        count: ''
      }
      this.rewardForm.coupons.splice(index + 1, 0, data)
    },
    /**
     * 删除删除一行优惠券
     */
    delCoupon(index) {
      this.rewardForm.coupons.splice(index, 1)
    },
    addCoupon2(index) {
      const data = {
        couponId: '',
        count: ''
      }
      this.rewardForm2.coupons.splice(index + 1, 0, data)
    },
    /**
     * 删除删除一行优惠券
     */
    delCoupon2(index) {
      this.rewardForm2.coupons.splice(index, 1)
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      let val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      val = val || ''
      return val.stock || 0
    },
    /**
     * 图片上传成功时的钩子函数
     */
    handleAvatarSuccess(res, file) {
      // this.form.image = URL.createObjectURL(file.raw);
      this.$set(this.configForm, 'activityCopywriting', res.data.fileName)
    },
    /**
     * 图片上传前的钩子函数
     */
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/gif'
      const isLt2M = file.size <= 1048576

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/JEPG/PNG/GIF 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1MB!')
      }
      return isJPG && isLt2M
    },
    /**
     * 树的节点筛选
     */
    filterNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some((label) => label.indexOf(value) !== -1)
    },
    /**
     * 提交
     */
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate((valid) => {
        ruleFormBool = valid
      })

      let configFormBool = false
      this.$refs['configForm'].validate((valid) => {
        configFormBool = valid
      })

      let configForm2Bool = false
      this.$refs['configForm2'].validate((valid) => {
        configForm2Bool = valid
      })

      let rewardFormBool = false
      this.$refs['rewardForm'].validate((valid) => {
        rewardFormBool = valid
      })
      let rewardForm2Bool = false
      this.$refs['rewardForm2'].validate((valid) => {
        rewardForm2Bool = valid
      })
      // 如果三个表单校验全部通过
      if (
        ruleFormBool &&
        configFormBool &&
        rewardFormBool &&
        rewardForm2Bool &&
        configForm2Bool
      ) {
        this.submitData()
      }
    },
    submitData() {
      // if-else的代替写法，策略模式，提高代码质量
      const stationOptions = {
        '1': () => {
          return ''
        },
        '2': () => {
          const newdata = this.$refs.treeOperator.getCheckedKeys()
          return newdata.join(',')
        },
        '3': () => {
          const newdata = this.$refs.treeStation.getCheckedKeys()
          return newdata.join(',')
        }
      }
      const userOptions = {
        '1': () => {
          return ''
        },
        '2': () => {
          const newdata = this.$refs.treeMechanism.getCheckedKeys()
          return newdata.join(',')
        },
        '3': () => {
          const newdata = this.$refs.treeTag.getCheckedKeys()
          return newdata.join(',')
        }
      }
      const newCoupons = []
      this.rewardForm.coupons.forEach(item => {
        const newobj = {
          count: item.count,
          couponId: item.couponId,
          targetType: 1
        }
        newCoupons.push(newobj)
      })
      this.rewardForm2.coupons.forEach(item => {
        const newobj1 = {
          count: item.count,
          couponId: item.couponId,
          targetType: 2
        }
        newCoupons.push(newobj1)
      })
      const data = {
        type: 7,
        id: this.dataId,
        name: this.ruleForm.activityName, // 活动名称
        start: this.ruleForm.activityTime[0], // 活动开始时间
        end: this.ruleForm.activityTime[1], // 活动结束时间
        description: this.ruleForm.activityExplain, // 活动说明
        img: this.configForm.activityCopywriting, // 活动文案
        rule: this.configForm.activityReason, // 组团规则
        minMembers: this.configForm2.activityGroup, // 成团人数
        consumptionType: this.configForm2.consumptionDimension, // 消费维度
        stationType: this.configForm2.stationType, // 活动电站
        // 活动电站下面的树的数据
        stationValue: stationOptions[this.configForm2.stationType](), // 字符串，以逗号分割
        userType: this.partakeForm.userType, // 可参与用户
        // 可参与用户下面的树的数据
        userValue: userOptions[this.partakeForm.userType](), // 字符串，以逗号分割
        // 活动配置
        coupons: [
          {
            amount: this.configForm2.amount, // 奖励标准
            coupons: newCoupons
          }
        ]
      }
      this.$store.dispatch('form/handle', {
        url: '/activity/save',
        data: data,
        method: 'post',
        callback: (resp) => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
            duration: 1500
          })
          this.$router.go(-1)
        }
      })
    },
    // 页面数据转换方法
    getData() {
      this.$store.dispatch('form/handle', {
        url: '/activity/get',
        data: { id: this.dataId },
        method: 'get',
        callback: (record) => {
          this.ruleForm = {
            activityName: record.name, // 活动名称
            activityTime: [record.start, record.end], // 活动时间
            activityExplain: record.description // 活动说明
          }
          this.configForm = {
            activityCopywriting: record.img,
            activityReason: record.rule
          }
          this.configForm2 = {
            stationType: record.stationType, // 活动电站单选框
            operator: record.stationType === '2' ? record.stationValue.split(',') : [],
            station: record.stationType === '3' ? record.stationValue.split(',') : [],
            activityGroup: record.minMembers,
            consumptionDimension: record.consumptionType,
            amount: record.coupons[0].amount
          }
          this.partakeForm = {
            userType: record.userType, // 可参与用户的单选字段
            mechanism: record.userType === '2' ? record.userValue.split(',') : [], // 选择企业
            tag: record.userType === '3' ? record.userValue.split(',') : [] // 选择标签
          }
          if (record.coupons && record.coupons[0].coupons) {
            this.rewardForm.coupons = []
            this.rewardForm2.coupons = []
            record.coupons[0].coupons.forEach(item => {
              if (item.targetType === '1') {
                this.rewardForm.coupons.push({
                  couponId: item.couponId, // 优惠券id
                  count: item.count // 优惠券数量
                })
              } else {
                this.rewardForm2.coupons.push({
                  couponId: item.couponId, // 优惠券id
                  count: item.count // 优惠券数量
                })
              }
            })
          }
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
/deep/.el-upload {
  width: 100%;
}
.imgborder {
  display: inline-block;
  width: 100%;
  height: 180px;
  text-align: center;
  line-height: 180px;
  border: 1px dashed #409eff;
  border-radius: 5px;
  i {
    font-size: 28px;
    color: #409eff;
  }
}
.avatar {
  max-height: 200px;
  width: auto;
}
.d-flex {
  display: flex;
}
.flexJCenter {
  display: flex;
  justify-content: center;
}
.mt-25 {
  margin-top: 25px;
}
.currentStock {
  height: 20px;
  align-items: center;
}
.ml-20 {
  margin-left: 20px;
}
.ml-10 {
  margin-left: 10px;
}
.mr-10 {
  margin-right: 10px;
}
.icon-jia {
  font-size: 22px;
  align-items: center;
  display: flex;
}
.border {
  border: 1px solid #eeeeee;
  padding: 20px;
  height: 300px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/groupModify.vue